import React, { useMemo } from 'react';
import { Flex, ClickableElement, TextInline } from '@cko/primitives';
import { IconActionChevronLeft, IconActionChevronRight } from '@cko/icons';
import styled from 'styled-components';
const IconButton = styled(ClickableElement) `
  display: flex;
  align-items: center;
  justify-content: center;

  width: 32px;
  height: 32px;
`;
const IconRight = styled(IconActionChevronRight) `
  height: 16px;
  width: 16px;
`;
const IconLeft = styled(IconActionChevronLeft) `
  height: 16px;
  width: 16px;
`;
const PageSelector = (props) => {
    const { isDisabled = false, onClickPreviousPage, onClickNextPage, page, pageCount } = props;
    const isLastPage = useMemo(() => {
        return page < pageCount;
    }, [pageCount, page]);
    const isFirstPage = useMemo(() => {
        return page > 1;
    }, [page]);
    const pageLabel = `${page} / ${pageCount}`;
    return (React.createElement(Flex, { alignItems: "center", gridGap: "var(--layout-soybean)", justifyContent: "space-between" },
        React.createElement(IconButton, { "data-testid": "pdf-viewer-page-selector-left", disabled: !isFirstPage || isDisabled, onClick: onClickPreviousPage },
            React.createElement(IconLeft, { fill: !isFirstPage || isDisabled
                    ? 'var(--action-icon-disabled)'
                    : 'var(--action-icon-primary)' })),
        React.createElement(TextInline, { color: isDisabled ? 'var(--base-text-secondary)' : 'var(--base-text-primary)', "data-testid": "pdf-viewer-page-selector-label", fontWeight: 500, textAlign: "center", width: "var(--layout-stadium)" }, pageLabel),
        React.createElement(IconButton, { "data-testid": "pdf-viewer-page-selector-right", disabled: !isLastPage || isDisabled, onClick: onClickNextPage },
            React.createElement(IconRight, { fill: !isLastPage || isDisabled ? 'var(--action-icon-disabled)' : 'var(--action-icon-primary)' }))));
};
export default PageSelector;
